import React from 'react'
import arrow_cat from '../assets/arrow_cat.svg'
function CategoryButton() {
  return (
    <div className='category-button-container' >
        View expenses
         &nbsp; 
        <img src={arrow_cat} alt="arrow" className="arrow"/>
    </div>
  )
}

export default CategoryButton